import ManageCultureVarieties from './ManageCultureVarieties'

export default ManageCultureVarieties
